<template>
  <div class="wrap">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        Список пользователей
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="720px" @close="close">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="mb-2 dialog-btn"
            v-bind="attrs"
            v-on="on"
            >Создать</v-btn
          >
        </template>
        <v-card>
          <v-card-text class="pt-4">
            <span class="headline">{{ formTitle }}</span>
            <v-form v-model="valid" ref="form">
              <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
                >Email</v-card-title
              >
              <v-text-field
                label="Введите Ваш email"
                v-model="editedItem.email"
                type="email"
                :rules="global.rules.email"
                autocomplete="username"
                required
              ></v-text-field>
              <template v-if="!editMode">
                <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
                  >Пароль</v-card-title
                >
                <v-text-field
                  label="Введите Ваш пароль"
                  v-model="editedItem.password"
                  min="8"
                  type="password"
                  :rules="[global.rules.required]"
                  autocomplete="new-password"
                  counter
                  required
                ></v-text-field>
              </template>
              <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
                >Права</v-card-title
              >
              <v-select
                :items="rolesList"
                :value="getCurrentRole(editedItem.roles)"
                item-text="text"
                item-value="value"
                :hide-details="true"
                filled
                @change="changeRole($event, editedItem)"
              >
              </v-select>
              <br />
              <v-card-title class="subtitle-1 pr-0 pl-0 pb-0"
                >Доступные лендинги</v-card-title
              >
              <v-select
                :items="landingList"
                v-model="editedItem.available_landings"
                item-text="name"
                item-value="id"
                :hide-details="true"
                attach
                chips
                multiple
              >
              </v-select>
              <br />
              <v-layout justify-space-between>
                <v-btn
                  @click="register"
                  :class="{
                    'blue darken-4 white--text': valid,
                    disabled: !valid
                  }"
                  >Сохранить</v-btn
                >
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <template v-if="items.length">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :selectedId="$store.getters.user.id"
          :items-per-page="20"
          :footer-props="{
            'items-per-page-options': [20, 50, 100, 200]
          }"
        >
          <template v-slot:item.actions="{ item }">
            <template v-if="item.id !== $store.getters.user.id">
              <v-btn
                color="primary"
                class="pl-0 pr-0 mr-3"
                @click="editUser(item)"
              >
                <v-icon left>
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                color="red"
                class="pl-0 pr-0 white--text"
                @click="deleteUser(item)"
              >
                <v-icon left>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <template v-else>
      <v-card-text>
        Список пользователей пуст
      </v-card-text>
    </template>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { GLOBAL } from "@/config/consts";
import { mapGetters } from "vuex";

export default {
  name: "Users",
  data() {
    return {
      dialog: false,
      overlay: false,
      editMode: false,
      items: [],
      search: "",
      headers: [
        { text: "ID пользователя", value: "id" },
        { text: "Email", value: "email" },
        { text: "Действия", value: "actions" }
      ],
      valid: false,
      multiLine: true,
      snackbar: false,
      errorText: "",
      global: GLOBAL,
      editedIndex: -1,
      editedItem: {
        id: "",
        name: "",
        password: "",
        roles: [],
        available_landings: []
      },
      defaultItem: {
        id: "",
        name: "",
        password: "",
        roles: [],
        available_blocks: []
      },
      defaultLandingsCount: 200,
      landingList: [],
      roleAdmin: "ROLE_ADMIN",
      roleDeveloper: "ROLE_DEVELOPER",
      roleUser: "ROLE_USER"
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    ...mapGetters(["getErrorText"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Создать пользователя"
        : "Редактировать пользователя";
    },
    rolesList() {
      return [
        {
          value: this.roleUser,
          text: "Менеджер"
        },
        {
          value: this.roleDeveloper,
          text: "Разработчик"
        },
        {
          value: this.roleAdmin,
          text: "Админ"
        }
      ];
    }
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.overlay = true;
      await this.getUsers();
      await this.getLandingList();
      this.overlay = false;
    },
    async getLandingList() {
      try {
        const { data } = await this.$axios.get(GLOBAL.apiUrl.landings, {
          params: {
            per_page: this.defaultLandingsCount
          }
        });
        this.landingList = data.list;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      }
    },
    editUser(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.editMode = true;
    },
    async deleteUser(item) {
      if (confirm("Вы уверены, что хотите удалить этот элемент?")) {
        try {
          const index = this.items.indexOf(item);
          await this.$axios.delete(GLOBAL.apiUrl.user + item.id);
          this.$delete(this.items, index);
        } catch ({ response }) {
          this.snackbar = true;
          this.errorText = this.getErrorText(response);
        }
      }
    },
    async getUsers() {
      try {
        this.overlay = true;
        const { data } = await this.$axios.get(GLOBAL.apiUrl.users);

        this.items = data.list;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    getCurrentRole(roles) {
      let role = this.rolesList[0]["value"];
      if (roles.includes(this.roleAdmin)) {
        role = this.roleAdmin;
      } else if (roles.includes(this.roleDeveloper)) {
        role = this.roleDeveloper;
      }

      return role;
    },
    async changeRole(role, item) {
      item.roles = [role];
      if (role === this.roleAdmin) {
        item.roles.push(this.roleDeveloper);
      }
    },
    async register() {
      if (!this.valid) {
        return;
      }
      const saveData = {
        email: this.editedItem.email,
        roles: this.editedItem.roles,
        available_landings: this.editedItem.available_landings
      };
      if (this.editMode) {
        await this.edit(saveData);
      } else {
        await this.create(saveData);
      }
    },
    async create(saveData) {
      saveData["password"] = this.editedItem.password;
      try {
        this.overlay = true;
        const { data } = await this.$axios.post(GLOBAL.apiUrl.user, saveData);

        this.items.unshift(data);
        this.dialog = false;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    async edit(saveData) {
      try {
        this.overlay = true;
        const { data } = await this.$axios.patch(
          GLOBAL.apiUrl.user + this.editedItem.id,
          saveData
        );

        Object.assign(this.items[this.editedIndex], data);
        this.dialog = false;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    },
    close() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.form.resetValidation();
        this.editMode = false;
        this.dialog = false;
      });
    }
  }
};
</script>

<style scoped>
.select-wrap {
  padding: 10px 0;
}
</style>
